/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/report/report.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { ReportRoutingModule } from "./report-routing.module";
import * as i0 from "@angular/core";
export class ReportModule {
    constructor() {
    }
}
ReportModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    ReportRoutingModule,
                ],
            },] },
];
/** @nocollapse */
ReportModule.ctorParameters = () => [];
/** @nocollapse */ ReportModule.ɵmod = i0.ɵɵdefineNgModule({ type: ReportModule });
/** @nocollapse */ ReportModule.ɵinj = i0.ɵɵdefineInjector({ factory: function ReportModule_Factory(t) { return new (t || ReportModule)(); }, imports: [[
            ReportRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ReportModule, { imports: [ReportRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ReportModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ReportRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwb3J0Lm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3Zpc2lvbmljcy9uZy9zcmMvYXBwL3JlcG9ydC9yZXBvcnQubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsbUJBQW1CLEVBQUMsTUFBTSx5QkFBeUIsQ0FBQzs7QUFPNUQsTUFBTSxPQUFPLFlBQVk7SUFDdkI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixtQkFBbUI7aUJBQ3BCO2FBQ0Y7Ozs7Z0RBQ1ksWUFBWTt1R0FBWixZQUFZLGtCQUpiO1lBQ1IsbUJBQW1CO1NBQ3BCO3dGQUVVLFlBQVksY0FIckIsbUJBQW1CO2tEQUdWLFlBQVk7Y0FMeEIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixtQkFBbUI7aUJBQ3BCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtSZXBvcnRSb3V0aW5nTW9kdWxlfSBmcm9tIFwiLi9yZXBvcnQtcm91dGluZy5tb2R1bGVcIjtcblxuQE5nTW9kdWxlKHtcbiAgaW1wb3J0cyA6IFtcbiAgICBSZXBvcnRSb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBSZXBvcnRNb2R1bGUge1xuICBjb25zdHJ1Y3RvcigpIHt9XG59XG4iXX0=